import { useState, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import styles from "./Header.module.scss";
import ExternalLink from "../../common/ExternalLink.js";
import InternalLink from "../../common/InternalLink.js";
import { WindowWidthContext } from "../../../contexts/WindowWidthProvider.js";
import Background from "../../common/Background.js";
import Logo from "../../common/Logo.js";
import ChainDropdown from "./ChainDropdown.js";
import ConnectButton from "./ConnectButton.js";
import LinkDropdown from "./LinkDropdown.js";
import ProviderModal from "./ProviderModal.js";
import { conc, cond, getCssVariablePixel } from "../../../../lib/html.js";
import { isTestnetPath } from "../../../../lib/helper.js";

export default function Header() {
	const mobileBreakpoint = getCssVariablePixel("--mobile-breakpoint-very-big");

	const pathname = window.location.pathname;

	const location = useLocation();

	const windowWidth = useContext(WindowWidthContext);

	const [isChecked, setIsChecked] = useState(false);
	const [isModalOpen, setIsModalOpen] = useState(false);

	// ---- HOOKS ----

	useEffect(() => {
		resetModal();
	}, [location]);

	useEffect(() => {
		if (isChecked === true && windowWidth > mobileBreakpoint) {
			setIsChecked(false);
		}
	}, [windowWidth]);

	// ---- FUNCTIONS ----

	function resetModal() {
		setIsChecked(false);
		setIsModalOpen(false);
	}

	// ---- HANDLE BUTTONS ----

	function handleConnectWalletButton() {
		setIsModalOpen(true);
	}

    return (
		windowWidth > mobileBreakpoint
		?
			<header className={conc(styles.header, styles.header_desktop)}>
				<Background isActive={isModalOpen} onClick={() => setIsModalOpen(false)}/>

				<Logo/>

				<nav className={styles.nav_desktop}>
					<ExternalLink link={"https://docs.magicyearn.io"} otherClasses={conc(styles.link, styles.link_transparent)}>Docs</ExternalLink>

					<LinkDropdown title={"dApps"} titleClassName={conc(styles.link, styles.link_transparent)}>
						<InternalLink link={"/dapps/staking"} otherClasses={conc(styles.link, cond(pathname === "/dapps/staking", styles.link_active))} onClick={resetModal}>Staking</InternalLink>
						<InternalLink link={"/dapps/mytokens"} otherClasses={conc(styles.link, cond(pathname === "/dapps/mytokens", styles.link_active))} onClick={resetModal}>MY Tokens</InternalLink>
						<InternalLink link={"/dapps/feereducer"} otherClasses={conc(styles.link, cond(pathname === "/dapps/feereducer", styles.link_active))} onClick={resetModal}>Fee Reducer</InternalLink>
					</LinkDropdown>

					<LinkDropdown title={"NFTs"} titleClassName={conc(styles.link, styles.link_transparent)}>
						<InternalLink link={"/nfts/mint"} otherClasses={conc(styles.link, cond(pathname === "/nfts/mint", styles.link_active))} onClick={resetModal}>Mint NFT</InternalLink>
						<InternalLink link={"/nfts/list"} otherClasses={conc(styles.link, cond(pathname === "/nfts/list", styles.link_active))} onClick={resetModal}>All NFTs</InternalLink>
						{
							isTestnetPath() &&
							<InternalLink link={"/nfts/marketplace"} otherClasses={conc(styles.link, cond(pathname === "/nfts/marketplace", styles.link_active))} onClick={resetModal}>NFT Marketplace</InternalLink>
						}
					</LinkDropdown>
				</nav>

				<div className={styles.function_container}>
					<ConnectButton onClick={handleConnectWalletButton}/>
					<ChainDropdown/>
				</div>

				{
					isModalOpen &&
					<ProviderModal closeModal={() => resetModal()}/>
				}
			</header>
		:
			<header className={conc(styles.header, styles.header_mobile)}>
				<Background isActive={isChecked || isModalOpen} onClick={() => resetModal()}/>
				
				<Logo/>

				<div className={styles.menu_button_container}>
					<input type="checkbox" className={styles.menu_checkbox} id="menu_toggle" onChange={(event) => setIsChecked(event.currentTarget.checked)} checked={isChecked}/>
					<label className={styles.menu_button} htmlFor="menu_toggle">
						<div className={styles.menu_button_part}></div>
					</label>

					{
						isModalOpen && isChecked
						?
							<ProviderModal closeModal={() => resetModal()}/>
						:
							<nav className={conc(styles.nav_mobile, cond(isChecked, styles.nav_mobile_visible))}>
								<ExternalLink link={"https://docs.magicyearn.io/"} otherClasses={styles.link}>Docs</ExternalLink>

								<hr/>

								<InternalLink link={"/dapps/staking"} otherClasses={conc(styles.link, cond(pathname === "/dapps/staking", styles.link_active))} onClick={resetModal}>Staking</InternalLink>
								<InternalLink link={"/dapps/mytokens"} otherClasses={conc(styles.link, cond(pathname === "/dapps/mytokens", styles.link_active))} onClick={resetModal}>MY Tokens</InternalLink>
								<InternalLink link={"/dapps/feereducer"} otherClasses={conc(styles.link, cond(pathname === "/dapps/feereducer", styles.link_active))} onClick={resetModal}>Fee Reducer</InternalLink>

								<hr/>

								<InternalLink link={"/nfts/mint"} otherClasses={conc(styles.link, cond(pathname === "/nfts/mint", styles.link_active))} onClick={resetModal}>Mint NFT</InternalLink>
								<InternalLink link={"/nfts/list"} otherClasses={conc(styles.link, cond(pathname === "/nfts/list", styles.link_active))} onClick={resetModal}>All NFTs</InternalLink>
								{
									isTestnetPath() &&
									<InternalLink link={"/nfts/marketplace"} otherClasses={conc(styles.link, cond(pathname === "/nfts/marketplace", styles.link_active))} onClick={resetModal}>NFT Marketplace</InternalLink>
								}

								<hr/>

								<div className={styles.function_container}>
									<ConnectButton onClick={handleConnectWalletButton}/>
									<ChainDropdown/>
								</div>
							</nav>
					}
				</div>
			</header>
    );
}